// Файл logic.js

import { sync_android_fcm_token } from '../services/fcm_token_sync';


// Бизнес-логика формы авторизации:
// - проверка полей,
// - запрос входа,
// - обработка ошибок и блокировки

/**
 * Создает функцию-обработчик для отправки данных авторизации
 * на сервер.
 * @param {Object} params - Объект с зависимостями
 * и state компонента.
 */
const build_going_after_authorization = ({
    var_8,
    var_10,
    is_pd_accepted,
    auth_lock_remaining,
    is_cookies_accepted,
    loading,
    phone_ref,
    password_ref,
    set_loading,
    set_response,
    set_auth_locked_until,
    showToast,
    apiService,
    redirect_after_login,
    save_cookie_consent_accepted,
}) => {
    return async (e) => {
        e.preventDefault();
        set_loading(true);

        // Сброс стилей ошибок
        phone_ref.current?.classList.remove('input-error');
        password_ref.current?.classList.remove('input-error');

        // Валидация полей
        if (!var_8 || var_8.trim() === '') {
            phone_ref.current?.classList.add('input-error');
            set_loading(false);
            return;
        }

        if (!var_10 || var_10.trim() === '') {
            password_ref.current?.classList.add('input-error');
            set_loading(false);
            return;
        }

        if (!is_pd_accepted) {
            showToast(
                'Необходимо согласие на обработку '
                + 'персональных данных',
                'error',
            );
            set_loading(false);
            return;
        }

        if (auth_lock_remaining > 0) {
            const remainingMinutes = Math.ceil(auth_lock_remaining / 60);
            showToast(
                'Авторизация заблокирована. Осталось '
                + `${remainingMinutes} мин.`,
                'error',
            );
            set_loading(false);
            return;
        }

        try {
            // Отправка запроса на авторизацию
            const response = await apiService.df({
                table_name: 'button_clicked',
                params: {
                    var_8,
                    var_10,
                    button_c: 'Войти',
                },
            });

            // Обновление стейта с ответом
            // сервера
            set_response(response.response || '');

            if (response.response === 'Вы авторизованы') {
                await apiService.refresh_csrf_token();
                sync_android_fcm_token({ force: true }).catch(() => {});

                // Логирование согласия
                // на обработку ПД
                apiService.df({
                    table_name: 'log_pd_consent',
                    params: {
                        consent: 'accepted',
                        version: '1.0',
                        acceptedAt: new Date().toISOString(),
                        phone: var_8,
                    },
                }).catch(() => {});

                // Сохранение согласия на куки
                if (is_cookies_accepted) {
                    save_cookie_consent_accepted();
                }

                // Выполнение редиректа
                // после успешного логина
                redirect_after_login();

            } else if (response.locked_until) {
                // Блокировка аккаунта
                set_auth_locked_until(response.locked_until);
                showToast(
                    'Авторизация заблокирована на 1 час после 5 '
                    + 'неверных попыток',
                    'error',
                );
            } else if (response.response) {
                // Отображение других ошибок
                // от сервера
                showToast(response.response, 'error');
            }
        } catch (err) {
            // Обработка сетевых
            // или непредвиденных ошибок
            showToast(`Ошибка: ${err.message}`, 'error');
        } finally {
            // Снятие состояния загрузки
            // в любом случае
            set_loading(false);
        }
    };
};

/**
 * Создает функцию для перенаправления пользователя
 * после успешной авторизации.
 * @param {Object} deps - Зависимости из react-router-dom.
 * @param {Function} deps.navigate - Функция для навигации.
 * @param {Object} deps.location - Текущее местоположение.
 * @returns {Function} Функция, выполняющая редирект.
 */
const build_redirect_after_login = ({ navigate, location }) => {
    return () => {
        // Получаем путь, откуда пришел пользователь,
        // или '/' по умолчанию
        const from = location.state?.from?.pathname || '/';
        // replace=true не позволяет кнопке «Назад»
        // вернуть страницу логина.
        navigate(from, { replace: true });
    };
};


// Экспорт обеих функций
// для использования в index.js
export {
    build_going_after_authorization,
    build_redirect_after_login,
};
